module.exports = __webpack_public_path__ + "data-center.svg?4045059496ceb71cd5a04a2e80f76032";